import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Modal, Table } from 'react-bootstrap';
import AppContext from 'context/Context';
import moment from 'moment';
const GRNsModal = ({ isShow, handleClose, wpoNo, data }) => {
  const {
    config: { isDark }
  } = useContext(AppContext);

  return (
    <Modal
      show={isShow}
      onHide={handleClose}
      size="lg"
      centered
      contentClassName="border"
    >
      <Modal.Header
        closeButton
        closeVariant={isDark ? 'white' : undefined}
        className="bg-light border-bottom-0"
      >
        <Modal.Title>
          <b>{wpoNo}</b>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Table bordered hover>
          <thead>
            <tr>
              <th style={{ width: 150 }}></th>
              <th>GRN No. </th>
              <th>Received</th>
            </tr>
          </thead>

          <tbody>
            {data?.map((x, i) => (
              <tr key={i}>
                <td>
                  <a href={`/stock-location/stock-management/wpo/grn/${x.grnNo}`} target="_blank" rel="noreferrer">
                    VIEW GRN
                  </a>
                </td>
                <td>{x.grnNo}</td>
                <td>{moment(x.received).format("DD/MM/YYYY")}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Modal.Body>
    </Modal>
  );
};

GRNsModal.propTypes = {
  isShow: PropTypes.bool,
  handleClose: PropTypes.func,
  wpoNo: PropTypes.string,
  data: PropTypes.array
};

export default GRNsModal;
